export default "__VITE_ASSET__MDZh5Tiv__"